import { ActivatedRouteSnapshot } from '@angular/router';
import { flatMap } from 'lodash-es';

export function getUrl(route: ActivatedRouteSnapshot): string {
  const url = flatMap(route.pathFromRoot.map((ss) => ss.url.map((u) => u.path))).join('/');
  return '/' + url;
}

export function getCompanyCodeFromRoute(route: ActivatedRouteSnapshot): string | undefined {
  return getRouteParam(route, 'companyCode');
}

export function getRegionIdFromRoute(route: ActivatedRouteSnapshot): string | undefined {
  return getRouteParam(route, 'regionId');
}

export function getCardNumberFromRoute(route: ActivatedRouteSnapshot): string | undefined {
  return getRouteParam(route, 'cardNumber');
}

export function getCommunicationCenterIdFromRoute(
  route: ActivatedRouteSnapshot,
): string | undefined {
  return getRouteParam(route, 'communicationCenterId');
}

export function getRouteOrQueryParam(
  route: ActivatedRouteSnapshot,
  paramName: string,
): string | undefined {
  return getRouteParam(route, paramName) ?? getRouteQueryParam(route, paramName);
}

export function getRouteParam(
  route: ActivatedRouteSnapshot,
  paramName: string,
): string | undefined {
  const param = route.pathFromRoot
    .map((p) => p.params[paramName] as string | undefined)
    .find((p) => p != null);
  return param;
}

export function getRouteQueryParam(
  route: ActivatedRouteSnapshot,
  queryParam: string,
): string | undefined {
  const param = route.pathFromRoot
    .map((p) => p.queryParams[queryParam] as string | undefined)
    .find((p) => p != null);
  return param;
}
